import { Container } from "aurelia-dependency-injection";
import { ApplicationInsights } from "./application-insights";

export class AjaxHelper {
    public static configureGlobalRequestHeaders() {
        $(document).ajaxSend((event, xhr, settings) => {
            const operationContext = Container.instance.get(ApplicationInsights).getOperationContext();
            if (operationContext) {
                xhr.setRequestHeader("x-ms-request-root-id", `${operationContext.id}`);
                // Not sure what this needs to be set to right now but the AI logging seems ok without it
                // xhr.setRequestHeader("x-ms-request-id", `${operationContext.id}`);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/ajax-helper.ts